<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Máquinas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold container-btn-cadastro items-center"
    >
      <div class="col-md-2 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <listaUnidadesSelect />
      </div>
    </div>

    <div class="q-mt-xl">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="filteredRows"
        dense
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        v-model:pagination="pagination"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template #header-cell-acompanhar="props">
          <q-th :props="props">
            Acompanhar
            <q-icon size="sm" color="blue" name="info">
              <q-tooltip class="bg-indigo" :offset="[10, 10]">
                Ative o Acompanhamento para receber alertas dos estoques minimos
                definidos de cada item em cada máquina
              </q-tooltip>
            </q-icon></q-th
          >
        </template>
        <template #body-cell-id="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">
              {{ props.row.id }}
            </span>
          </q-td>
        </template>
        <template #body-cell-name="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">
              {{ props.row.name }}
            </span>
          </q-td>
        </template>
        <template #body-cell-location="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">
              {{ props.row.location }}
            </span>
          </q-td>
        </template>
        <template #body-cell-status="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">
              {{ props.row.status }}
            </span>
          </q-td>
        </template>
        <template #body-cell-bateria="props">
          <q-td>
            <span class="column" v-if="props.row.telemetria.batteryLevel">
              <span class="q-ml-sm text-brand-5 text-weight-bold">100%</span
              ><q-icon size="md" color="blue" name="power_settings_new"
            /></span>
            <span class="column" v-else>
              <span class="q-ml-sm text-brand-5 text-weight-bold">0%</span>
              <q-icon size="md" color="blue" name="power_settings_new"
            /></span>
          </q-td>
        </template>
        <template #body-cell-versao="props">
          <q-td>
            <div class="column text-brand-5 text-weight-bold">
              <span v-if="props.row.telemetria.versionName">{{
                props.row.telemetria.versionName
              }}</span>
              <q-icon
                class="cursor"
                size="md"
                color="blue"
                name="arrow_downward"
                @click="pedidoAtualizar(props.row.id)"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-sincronizar="props">
          <q-td>
            <div class="column text-brand-5 text-weight-bold">
              <span v-if="props.row.telemetria.date"
                >{{
                  props.row.telemetria.date
                    .split("T")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
                {{ props.row.telemetria.date.split("T")[1] }}</span
              >
              <q-icon
                class="cursor"
                size="md"
                color="blue"
                name="refresh"
                @click="sincronizar(props.row.id)"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-detalhes="props">
          <q-td>
            <q-btn
              color="primary"
              round
              class="q-ml-sm"
              flat
              icon="send"
              @click="detalhes(props.row.id, props.row.location)"
            />
          </q-td>
        </template>
        <template #body-cell-acompanhar="props">
          <q-td>
            <q-toggle
              size="lg"
              v-model="props.row.watching"
              @click="acompanhar(props.row.id, props.row.user_id)"
            />
          </q-td>
        </template>
        <template #body-cell-telemetria="props">
          <q-td>
            <q-btn
              color="black"
              flat
              round
              class="q-ml-sm"
              icon="query_stats"
              @click="telemetria(props.row.id, props.row.location)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "credential_id",
    label: "ID Credencial",
    field: (row) => row?.usuario_maquina?.id || "-",
    align: "left",
  },
  {
    name: "nome_equipamento",
    label: "Nome Equipamento",
    field: (row) => row.location,
    align: "left",
  },
  {
    name: "tipo_equipamento",
    label: "Tipo Equipamento",
    field: (row) => row.type,
    align: "left",
  },
  {
    name: "conexao",
    label: "Conexão",
    field: (row) => row?.tipo_conexao || "",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    field: "detalhes",
    align: "left",
  },
  {
    name: "acompanhar",
    label: "Acompanhar",
    field: "acompanhar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { ListaUnidadesSelect, PageHeader },
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const router = useRouter();
    const unidade = ref();
    let filter = ref("");

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 0,
    });

    const normalizeSearchText = (value) =>
      String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

    const buildMachineSearchText = (row) =>
      [
        row?.id,
        row?.user_id,
        row?.usuario_maquina?.id,
        row?.usuario_maquina?.sap,
        row?.location,
        row?.type,
        row?.tipo_conexao,
      ]
        .map((item) => String(item || ""))
        .join(" ");

    const filteredRows = computed(() => {
      const term = normalizeSearchText(filter.value);

      if (!term) {
        return rows.value;
      }

      return rows.value.filter((row) =>
        normalizeSearchText(buildMachineSearchText(row)).includes(term)
      );
    });

    const getMachines = async (page = 1, rowsPerPage = 50) => {
      disable.value = true;

      try {
        let response = await store.dispatch("maquina/listar", {
          vendor_id: store.state.org.unidadeData.id,
          per_page: rowsPerPage,
          page: page,
        });

        const results = response?.data?.results || {};
        const machineRows = Array.isArray(results?.data) ? results.data : [];

        rows.value = machineRows;
        pagination.value.rowsNumber = Number(results?.total || 0);
        pagination.value.rowsPerPage = Number(results?.per_page || rowsPerPage);
        pagination.value.page = Number(results?.current_page || page);
      } catch (error) {
        rows.value = [];
        pagination.value.rowsNumber = 0;

        $q.notify({
          message: "Erro ao carregar máquinas",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } finally {
        disable.value = false;
      }
    };

    onMounted(getMachines);

    const handleRequest = async () => {
      getMachines(pagination.value.page, pagination.value.rowsPerPage);
    };

    const pedidoAtualizar = async (id) => {
      try {
        await store.dispatch("maquina/atualizar", {
          id: id,
        });

        $q.notify({
          message: "Pedido de atualização enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMachines();
      } catch (error) {
        $q.notify({
          message: "Erro a o enviar pedido de atualização",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const sincronizar = async (id) => {
      try {
        await store.dispatch("maquina/sincronizar", {
          id: id,
        });

        $q.notify({
          message: "Pedido de sincronização enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMachines();
      } catch (error) {
        $q.notify({
          message: "Erro a o enviar pedido de sincronização",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const acompanhar = async (id, user) => {
      try {
        await store.dispatch("maquina/acompanhar", {
          id: id,
          users: [{ id: user }],
        });

        $q.notify({
          message: "Acompanhar com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMachines();
      } catch (error) {
        $q.notify({
          message: "Erro a o tentar Acompanhar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const detalhes = async (id, name) => {
      let dados = { id: id, nome: name };
      router.push({
        name: "maquina-detalhes",
        params: { id: JSON.stringify(dados) },
      });
    };

    const telemetria = async (id, local) => {
      router.push({
        name: "maquina-telemetria",
        params: { maquina: JSON.stringify({ nome: local, id: id }) },
      });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getMachines();
        }, 1000);
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getMachines();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      columns,
      rows,
      filteredRows,
      getMachines,
      pagination,
      handleRequest,
      disable,
      filter,
      unidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pedidoAtualizar,
      sincronizar,
      telemetria,
      detalhes,
      acompanhar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
</style>
